export enum CpwExceptionType {
    PickingDamagedProduct = '7A9381C2-075D-465F-7112-08DE58598949',
    PickingQuantityMismatch = '396D4177-96FB-4B08-7113-08DE58598949',
    PickingLocationInaccessible = '18A8CCCC-371F-4CB1-7114-08DE58598949',
    PickingSafetyIssue = '428937C6-BA93-46DD-7115-08DE58598949',
    ReceivingWrongWarehouse = '8F1F4B44-0CC4-44A6-43D3-08DE811D4498',
    ReceivingDuplicatePO = 'CBA87DC4-107C-422D-43D4-08DE811D4498',
    ReceivingShort = 'BDB4AA61-84B8-4D6B-3875-08DE852F1138',
    ReceivingOverage = '8C2CEB54-6A29-40EF-3876-08DE852F1138',
    ReceivingDamagedProduct = '610BCC1B-1D41-4C42-3877-08DE852F1138',
    ReceivingWrongItem = '09FB020F-E5CC-4474-3878-08DE852F1138',
    ReceivingMissingItemCatalog = 'FD62FBD3-E60D-4CD9-9394-A6FEA97D4AFF',
}

export enum CpwExceptionCategory {
    Other = 'Other',
    Damage = 'Damage',
    Variance = 'Variance',
    Obstructed = 'Obstructed',
    Safety = 'Safety',
    NonCompliance = 'NonCompliance',
}

export const CpwExceptionCategories = {
    [CpwExceptionCategory.Other]: {
        name: '',
        color: 'var(--pf-warning-color)',
    },
    [CpwExceptionCategory.Damage]: {
        name: 'Damage',
        color: 'var(--pf-error-color)',
    },
    [CpwExceptionCategory.Variance]: {
        name: 'Variance',
        color: 'var(--pf-success-color)',
    },
    [CpwExceptionCategory.Obstructed]: {
        name: 'Obstructed',
        color: '#856464',
    },
    [CpwExceptionCategory.Safety]: {
        name: 'Safety',
        color: '#dc3545',
    },
    [CpwExceptionCategory.NonCompliance]: {
        name: 'Non-Compliance',
        color: '#6c757d',
    },
};

export const CpwExceptionTypes = {
    [CpwExceptionType.PickingDamagedProduct]: {
        id: CpwExceptionType.PickingDamagedProduct,
        color: CpwExceptionCategories[CpwExceptionCategory.Damage].color,
    },
    [CpwExceptionType.PickingQuantityMismatch]: {
        id: CpwExceptionType.PickingQuantityMismatch,
        color: CpwExceptionCategories[CpwExceptionCategory.Variance].color,
    },
    [CpwExceptionType.PickingLocationInaccessible]: {
        id: CpwExceptionType.PickingLocationInaccessible,
        color: CpwExceptionCategories[CpwExceptionCategory.Obstructed].color,
    },
    [CpwExceptionType.PickingSafetyIssue]: {
        id: CpwExceptionType.PickingSafetyIssue,
        color: CpwExceptionCategories[CpwExceptionCategory.Safety].color,
    },
};
